export default __webpack_public_path__ + "static/media/facebook.73d66e35.svg";